/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BudgetAdvancedFilterDetailsRegions {
    getFixupPrototypeFunction() { return BudgetAdvancedFilterDetailsRegions.fixupPrototype; }

    static newInstance(model: Partial<BudgetAdvancedFilterDetailsRegions>): BudgetAdvancedFilterDetailsRegions {
        let obj = Object.assign(new BudgetAdvancedFilterDetailsRegions(), model);
        BudgetAdvancedFilterDetailsRegions.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BudgetAdvancedFilterDetailsRegions>): BudgetAdvancedFilterDetailsRegions {
        if (!model) return null;
        return BudgetAdvancedFilterDetailsRegions.newInstance(<BudgetAdvancedFilterDetailsRegions> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BudgetAdvancedFilterDetailsRegions) {
        if (!obj) return;

        models.BudgetAdvancedFilterDetailsRegions.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BudgetAdvancedFilterDetailsRegions): boolean {
        Object.setPrototypeOf(obj, BudgetAdvancedFilterDetailsRegions.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.region) {
            for (let val of this.region) {
                models.BudgetFilterRegion.fixupPrototype(val);
            }
        }
    }

    region: Array<models.BudgetFilterRegion>;

}
